'use strict';
import * as $j_app$002eapi$002e$002dDrug$002dRequest$002dPharmacy$002dState$0024$002dChat$002dStarted from "./app.api.-Drug-Request-Pharmacy-State$-Chat-Started.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestPharmacyState$Both$$anon$23(evaluator$15) {
  this.Lapp_api_DrugRequestPharmacyState$Both$$anon$23__f_evaluator$7 = null;
  this.Lapp_api_DrugRequestPharmacyState$Both$$anon$23__f_evaluator$7 = evaluator$15;
}
export { $c_Lapp_api_DrugRequestPharmacyState$Both$$anon$23 as $c_Lapp_api_DrugRequestPharmacyState$Both$$anon$23 };
$c_Lapp_api_DrugRequestPharmacyState$Both$$anon$23.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestPharmacyState$Both$$anon$23.prototype.constructor = $c_Lapp_api_DrugRequestPharmacyState$Both$$anon$23;
/** @constructor */
function $h_Lapp_api_DrugRequestPharmacyState$Both$$anon$23() {
}
export { $h_Lapp_api_DrugRequestPharmacyState$Both$$anon$23 as $h_Lapp_api_DrugRequestPharmacyState$Both$$anon$23 };
$h_Lapp_api_DrugRequestPharmacyState$Both$$anon$23.prototype = $c_Lapp_api_DrugRequestPharmacyState$Both$$anon$23.prototype;
$c_Lapp_api_DrugRequestPharmacyState$Both$$anon$23.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestPharmacyState$Both$$anon$23.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_DrugRequestPharmacyState$Both$$anon$23__f_evaluator$7.apply__O();
  return ((v instanceof $j_app$002eapi$002e$002dDrug$002dRequest$002dPharmacy$002dState$0024$002dChat$002dStarted.$c_Lapp_api_DrugRequestPharmacyState$ChatStarted) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_DrugRequestPharmacyState$Both$$anon$23.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_DrugRequestPharmacyState$Both$$anon$23 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestPharmacyState$Both$$anon$23, "app.api.DrugRequestPharmacyState$Both$$anon$23", ({
  Lapp_api_DrugRequestPharmacyState$Both$$anon$23: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestPharmacyState$Both$$anon$23 as $d_Lapp_api_DrugRequestPharmacyState$Both$$anon$23 };
//# sourceMappingURL=app.api.-Drug-Request-Pharmacy-State$-Both$$anon$23.js.map
